import { c as e, d as t, o as n } from "./_plugin-vue_export-helper-B-med9Jm.js";
import { SEARCH_DEBOUNCE as r, VuetifyValidationRules as i, formatDate as a, formatDateddMMyyyy as o } from "@editor/ui-utils";
import { QItem as s, QItemLabel as c, QItemSection as l, QSelect as u, QTooltip as d } from "quasar";
import { computed as f, createBlock as p, createCommentVNode as m, createElementBlock as h, createTextVNode as g, createVNode as _, defineComponent as v, mergeProps as y, nextTick as b, normalizeProps as x, onMounted as S, openBlock as C, ref as w, toDisplayString as T, unref as E, watch as D, withCtx as O } from "vue";
import { useI18n as k } from "vue-i18n";
//#region src/components/author-dropdown-selector.vue?vue&type=script&setup=true&lang.ts
var A = { key: 0 }, j = {
	key: 1,
	class: "text-grey"
}, M = /* @__PURE__ */ v({
	__name: "author-dropdown-selector",
	props: {
		modelValue: { default: void 0 },
		multiple: {
			type: Boolean,
			default: !1
		},
		disable: {
			type: Boolean,
			default: !1
		},
		required: {
			type: Boolean,
			default: !1
		},
		clearable: {
			type: Boolean,
			default: void 0
		},
		source: { default: void 0 },
		disableMerged: {
			type: Boolean,
			default: void 0
		},
		hasExtendedAuthorInfo: {
			type: Boolean,
			default: !1
		},
		targetBrand: { default: void 0 },
		authors: { default: void 0 }
	},
	emits: ["update:modelValue"],
	setup(v, { expose: M, emit: N }) {
		let P = k().t, F = v, I = N, L = w(F.authors ?? []), R = w(!1), z = w(""), B = w(), V = 0, H = (e) => e == null || e === "" || Array.isArray(e) && e.length === 0, U = () => F.multiple ? [] : void 0, W = f(() => F.clearable ?? !F.multiple), G = f(() => L.value.map((e) => ({
			label: `${e.firstname} ${e.lastname}`,
			value: e._id,
			legacyId: e.legacy.id,
			lastUpdate: e.changeDate
		}))), K = async () => {
			let e = F.modelValue;
			return H(e) ? [] : t(Array.isArray(e) ? [...e] : [e], L.value);
		};
		async function q() {
			let t = ++V;
			R.value = !0;
			try {
				let r = z.value.trim();
				if (!r && F.authors !== void 0) {
					let n = await K();
					if (t !== V) return;
					L.value = e(F.authors, n);
					return;
				}
				let { list: i } = await n(r || void 0, {
					isEnabled: !0,
					source: F.source,
					disableMerged: F.disableMerged,
					targetBrand: F.targetBrand
				});
				if (t !== V) return;
				if (r) {
					L.value = i;
					return;
				}
				let a = await K();
				if (t !== V) return;
				L.value = e(i, a);
			} finally {
				t === V && (R.value = !1);
			}
		}
		function J(e, t) {
			t(async () => {
				z.value = e, await q();
			});
		}
		async function Y() {
			z.value = "", await q(), await b(), B.value?.showPopup();
		}
		let X = f({
			get: () => F.modelValue,
			set: (e) => {
				let t = H(e) && !H(F.modelValue);
				H(e) ? I("update:modelValue", U()) : I("update:modelValue", e), t && Y();
			}
		}), Z = f(() => F.required ? [i.required] : []);
		return M({ authorsList: L }), S(q), D(() => F.authors, () => {
			z.value.trim() || q();
		}), D(() => F.modelValue, async () => {
			if (H(F.modelValue)) return;
			let t = await K();
			L.value = e(L.value, t);
		}), (e, t) => (C(), p(E(u), y({
			ref_key: "selectRef",
			ref: B,
			modelValue: X.value,
			"onUpdate:modelValue": t[0] ||= (e) => X.value = e,
			dense: "",
			outlined: "",
			label: E(P)("authors.selectAuthors"),
			"use-chips": v.multiple,
			multiple: v.multiple,
			"input-debounce": E(r),
			"emit-value": "",
			"map-options": "",
			"use-input": "",
			clearable: W.value,
			"clear-icon": W.value ? "x" : void 0,
			"dropdown-icon": "expand_more",
			disable: v.disable,
			options: G.value,
			loading: R.value,
			rules: Z.value
		}, e.$attrs, { onFilter: J }), {
			"no-option": O(() => [_(E(s), null, {
				default: O(() => [_(E(l), { class: "text-grey" }, {
					default: O(() => [g(T(R.value ? E(P)("authors.loading") : E(P)("authors.noResults")), 1)]),
					_: 1
				})]),
				_: 1
			})]),
			"selected-item": O((e) => [e.opt && typeof e.opt == "object" && e.opt.label ? (C(), h("span", A, T(e.opt.label), 1)) : H(v.modelValue) ? m("", !0) : (C(), h("span", j, "…"))]),
			option: O((e) => [v.hasExtendedAuthorInfo ? (C(), p(E(s), y({ key: 0 }, e.itemProps, { class: "relative-position" }), {
				default: O(() => [_(E(l), null, {
					default: O(() => [_(E(c), null, {
						default: O(() => [g(T(e.opt.label), 1)]),
						_: 2
					}, 1024), _(E(c), { caption: "" }, {
						default: O(() => [g(T(e.opt.legacyId), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024), _(E(l), {
					side: "",
					top: ""
				}, {
					default: O(() => [_(E(c), { caption: "" }, {
						default: O(() => [g(T(E(o)(e.opt.lastUpdate)) + " ", 1), _(E(d), null, {
							default: O(() => [g(T(`${E(P)("authorsSelector.changeDateLabel")}: ${E(a)(e.opt.lastUpdate)}`), 1)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1040)) : (C(), p(E(s), x(y({ key: 1 }, e.itemProps)), {
				default: O(() => [_(E(l), null, {
					default: O(() => [_(E(c), null, {
						default: O(() => [g(T(e.opt.label), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1040))]),
			_: 1
		}, 16, [
			"modelValue",
			"label",
			"use-chips",
			"multiple",
			"input-debounce",
			"clearable",
			"clear-icon",
			"disable",
			"options",
			"loading",
			"rules"
		]));
	}
});
//#endregion
export { M as t };

//# sourceMappingURL=author-dropdown-selector-DY4fxs1F.js.map